import type { JSX } from "react"
import { useAppSelector } from "../../app/hooks"
import { Bird } from "lucide-react"
import type { Result, UserResource } from "@/utils/types"
import { decimalToPercent } from "@/lib/utils"
import { StatCard } from "./StatCard"
import { LanguagePie } from "./LanguagePie"
import { LanguageRadar } from "./LanguageRadar"

type ProfileHeaderProps = {
  user: UserResource
  results: Result[]
  highscores: Result[]
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({ user, results, highscores }): JSX.Element | null => {
  //   const homeSlice = useAppSelector(state => state.home)
  const authSlice = useAppSelector(state => state.auth)

  return (
    <div className="flex flex-col gap-2 p-4 bg-gray-800 text-white rounded-lg shadow-md">
      <div className="flex flex-row gap-4">
        {authSlice.user?.picture ? (
          //   <img src={authSlice.user.picture} className="w-16 h-16 rounded-full shadow-md"></img> // currently only works for own image
          //   <div className="w-15 h-15 flex justify-center items-center rounded-full">
          //     <Bird className="w-12 h-12" />
          //   </div>
          <Bird className="w-16 h-16" />
        ) : (
          <Bird className="w-16 h-16" />
        )}
        <div>
          <h2 className="text-2xl">{user.username}</h2>
          <p className="text-sm text-muted-foreground">{user.status}</p>
        </div>
      </div>
      <div className="flex flex-row justify-between px-4 py-2">
        <div className="flex flex-col gap-1">
          <StatCard className="text-white" description="total runs" value={user.total_runs} />
          <StatCard
            className="text-white"
            description="average accuracy"
            value={decimalToPercent(user.accuracy / user.total_runs)}
          />
        </div>
        <div className="flex flex-col gap-1">
          <StatCard className="text-white" description="total words" value={user.total_words} />
          <StatCard className="text-white" description="total time" value={user.total_time} />
        </div>
        <div className="flex flex-col gap-1">
          <StatCard className="text-white" description="streak🔥" value={user.streak} />
          <StatCard
            className="text-white"
            description="member since"
            value={new Date(user.created_at).toLocaleDateString("en-GB")}
          />
        </div>
        <LanguagePie results={results} total_runs={user.total_runs} />
        {/* should be >= 3 unique highscore languages, not just length >= 3 */}
        {highscores.length >= 3 && <LanguageRadar highscores={highscores} />}
      </div>
    </div>
  )
}
